exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// /Users/v625154/work/perspective/node_modules/core-js/modules/_wks-ext.js
// module id = 110
// module chunks = 0